<template>
    <div class="main-container has-table">
        <el-alert v-if="is_allocation" class="follow-alert" type="error">
            <p>为确保能及时接收到新订单微信提醒，请关注&nbsp;<el-link type="primary" @click="onOpenFollowDialog">蛋糕叔叔公众号</el-link></p>
        </el-alert>
        <div class="filter-container" ref="filterContainer">
            <el-select-v2
                v-if="hasShop && shopUserList.length > 1"
                class="filter-item"
                v-model="filters.shop_user_id"
                filterable
                clearable
                :options="shopUserList"
                :props="{
                    value: 'id',
                    label: 'shop_description'
                }"
                placeholder="商户列表"
                style="width:150px"
            />
            <SelectMerchantSecondBrand
                v-model="filters.tmp_secondary_id"
                :multiple="true"
                :collapseTags="true"
                :maxCollapseTags="2"
                style="width:280px"
                @change="onSelectedSecondBrandChange"
            />
            <el-select class="filter-item" v-model="filters.order_type" placeholder="订单类型" clearable>
                <el-option value="3" label="全部"></el-option>
                <template v-if="is_allocation">
                    <el-option v-if="hasShop" :value="0" label="未分配"></el-option>
                    <el-option v-if="!hasShop" :value="5" label="未接单"></el-option>
                </template>
                <el-option :value="1" label="未处理"></el-option>
                <el-option :value="2" label="已处理"></el-option>
                <el-option :value="4" label="已退款"></el-option>
            </el-select>
            <!-- <el-select class="filter-item" filterable v-model="filters.delivery_type" placeholder="商品状态" clearable>
                <el-option value="1" label="待发货"></el-option>
                <el-option value="2" label="48h未发货"></el-option>
            </el-select> -->
            <el-select class="filter-item" v-model="filters.reject_status" placeholder="审核状态" clearable>
                <el-option :value="0 + ''" label="待审核"></el-option>
                <el-option :value="1 + ''" label="审核通过"></el-option>
                <el-option :value="3 + ''" label="已驳回"></el-option>
            </el-select>
            <el-input class="filter-item" v-model.trim="filters.order_no" placeholder="订单号" clearable></el-input>
            <el-input class="filter-item" v-model.trim="filters.name" placeholder="收货人" clearable></el-input>
            <el-input class="filter-item" v-model.trim="filters.phone" placeholder="手机号" clearable></el-input>
            <!-- <el-select class="filter-item" v-model="filters.time_type" placeholder="时间类型">
                <el-option :value="1" label="支付时间"></el-option>
                <el-option :value="2" label="配送时间"></el-option>
            </el-select> -->
            <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="支付开始时间"
                value-format="YYYY-MM-DD" :disabled-date="disabledStartDate"></el-date-picker>
            <span class="filter-item filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="支付结束时间"
                value-format="YYYY-MM-DD" :disabled-date="disabledEndDate"></el-date-picker>
            <el-date-picker class="filter-item" v-model="filters.yushou_start_date" placeholder="预售开始时间"
                value-format="YYYY-MM-DD"></el-date-picker>
            <span class="filter-item filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.yushou_end_date" placeholder="预售结束时间"
                value-format="YYYY-MM-DD"></el-date-picker>
            <el-input class="filter-item" v-model="filters.item_name" placeholder="商品名称" style="width:200px"
                clearable></el-input>
            <el-button-group class="filter-item">
                <el-button :type="filters.timeClick == 1 ? 'primary' : 'default'" id="today"
                    @click="search(1)">今日</el-button>
                <el-button :type="filters.timeClick == 2 ? 'primary' : 'default'" id="yesterday"
                    @click="search(2)">昨日</el-button>
                <el-button :type="filters.timeClick == 3 ? 'primary' : 'default'" id="seven_day"
                    @click="search(3)">近七天</el-button>
            </el-button-group>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-checkbox class="filter-item" v-model="filters.is_history" @change="onHistoryChange">历史订单</el-checkbox>
            <template v-if="store.state.user.userInfo.id != 6079">
                <el-button class="filter-btn" type="primary" @click="output()">批量导出</el-button>
                <el-button class="filter-btn" type="primary" @click="batchDelivery('order')">按订单批量发货</el-button>
                <el-button class="filter-btn" type="primary" @click="batchDelivery('product')">按商品批量发货</el-button>
            </template>
            <router-link class="filter-item" target="_blank" :to="{ path: '/merchant/logistics-company' }">
                <el-button type="primary">查看物流公司</el-button>
            </router-link>
            <el-button class="filter-btn" type="primary" v-if="filters.is_yushou == '0'"
            @click="router.push('/merchant-admin/order-list?is_yushou=1')">
            搜索预售订单</el-button>
            <span style="color:#F56C6C;font-weight:bold;" @click="onPreview">☆必看，蛋糕添加收费附件操作手册☆</span>
        </div>
        <el-row justify="end" class="mb10">
            <el-link @click="router.push('/merchant-admin/refund-list')" type="primary">特殊退款订单列表>></el-link>
        </el-row>
        <el-table :data="tableData" border :span-method="objectSpanMethod" :row-class-name="rowClassName" v-loading="isLoading">
            <!-- <el-table-column prop="order_id" label="订单id"></el-table-column> -->
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column label="商品">
                <template #default="scope">
                    <el-image style="width: 50px; height: 40px" :src="scope.row.image_path" :zoom-rate="1.2"
                        :preview-src-list="srcList" fit="cover" @click="srcList = [scope.row.image_path]" :z-index="1000"
                        :preview-teleported="true" />
                </template>
            </el-table-column>
            <el-table-column label="商品信息" width="170">
                <template #default="scope">
                    <div class="ellipsis" :title="scope.row.brand_name">品牌：{{ scope.row.brand_name }}</div>
                    <a :title="scope.row.product_name" :href="`${Keys.dsUrl}/h5/product/show?id=${scope.row.product_id}`"
                        target="_blank">商品：{{ scope.row.product_name }}</a>
                    <div :title="scope.row.spec_name">规格：{{ scope.row.spec_name }}</div>
                    <!-- 品牌：{{scope.row.brand_name}}<br/>商品：{{scope.row.product_name}}<br/>规格：{{scope.row.spec_name}}<br/> -->
                </template>
            </el-table-column>
            <el-table-column prop="price" label="单价/数量">
                <template #default="scope">
                    {{ `${scope.row.price}` }} /
                    <b class="color-danger">{{ `${scope.row.quantity}` }}</b>
                </template>
            </el-table-column>
            <el-table-column prop="ship_amount" label="运费" width="60px"></el-table-column>
            <el-table-column prop="total_amount" label="订单金额"></el-table-column>
            <!-- <el-table-column prop="fine_price" label="罚款金额"></el-table-column> -->
            <el-table-column label="发货信息" width="152">
                <template #default="scope">
                    收货人：{{ scope.row.name }}<br />手机号：{{ scope.row.phone }}<br />
                    <span v-if="scope.row.status == 3">退款时间:{{ scope.row.refund_time }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="take_shop_name" label="配送门店"></el-table-column> -->
            <!-- <el-table-column label="商品状态">
                <template #default="scope">
                    <template v-if="scope.row.status == 3">
                        <span>已退款</span>
                    </template>
                    <template v-else>
                        <span v-if="scope.row.express_cp">已发货</span>
                        <span v-if="scope.row.delivery_type == 1">
                            待发货
                        </span>
                        <span v-else-if="scope.row.delivery_type == 2">
                            48小时未发货
                        </span>
                        <span v-if="scope.row.express_cp == '' || scope.row.express_cp == null">未发货</span>
                    </template>
                </template>
            </el-table-column> -->
            <el-table-column label="配送时间">
                <template #default="scope">
                    {{ scope.row.ship_date === '0000-00-00' ? '' :  `${scope.row.ship_date}    ` }}{{ scope.row.ship_time_text }}
                </template>
            </el-table-column>
            <el-table-column prop="paid_at" label="支付时间" width="95px"></el-table-column>
            <el-table-column prop="express_at" label="单号上传时间" width="100px"></el-table-column>
            <el-table-column label="预售时间" width="95px" v-if="filters.is_yushou == 1">
                <template #default="scope">
                    {{ scope.row.yushou_date }}至{{ scope.row.yushou_end_date }}
                </template>
            </el-table-column>
            <el-table-column label="审核状态" width="100px">
                <template #default="scope">
                    <div v-if="scope.row.reject_status == 0">待审核</div>
                    <div v-else-if="scope.row.reject_status == 1">审核通过</div>
                    <div v-else-if="scope.row.reject_status == 3">已驳回</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" width="160px">
                <template #default="scope">
                    <p>{{ scope.row.seller_msg }}</p>
                </template>
            </el-table-column>
            <el-table-column label="延迟发货" width="204px">
                <template #default="scope">
                        <div v-if="scope.row.reject_status == 3" style="color:#F56C6C">延迟发货被驳回原因：{{ scope.row.reject_reson }}</div>
                        <div v-else-if="scope.row.reject_status != null && scope.row.reject_status != undefined">
                            <div style="font-weight:bold">审核状态：{{ DelayStatus[scope.row.reject_status] }}</div>
                            <div>延迟类型：{{ DelayTypes[scope.row.delay_delivery_type] }}</div>
                            <div>延迟时间：{{ scope.row.delay_delivery_time }}</div>
                            <div>延迟原因：{{ scope.row.delay_reson }}</div>
                        </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="184px">
                <template #default="scope">
                    <div class="action-list">
                        <!--
                            总商户功能：
                                接单：选择门店进行接单，接单完成后可进行发货处理 => 签收处理
                                分配：选择门店账号（即关联了门店账号的门店）进行分配，分配后无发货处理权限 和 签收处理权限
                            门店账号功能：
                                接单：对分配到此门店的订单进行接单操作，接单后可进行发货处理 => 签收处理
                        -->
                        <!-- 接单：未接单状态 && （总商户且未分配（旧数据可能出现未接单状态但已分配）|| 门店账号）；总商户接单弹出可分配门店，门店账号接单直接调用接口 -->
                        <template v-if="is_allocation">
                            <el-button
                                v-if="scope.row.canPick"
                                @click="hasShop ? openDistribute(scope.row, 2): onPick(scope.row.order_id)"
                                type="primary"
                                size="small"
                                style="margin-bottom: 10px;"
                            >接单</el-button>
                            <!-- 总商户分配：总商户账号 && 订单待确认（未分配）状态 && 非快递类 -->
                            <!-- <el-button
                                v-if="scope.row.canDistribute"
                                type="primary"
                                size="small"
                                style="margin-bottom: 10px;"
                                @click="openDistribute(scope.row)"
                            >分配</el-button> -->
                        </template>
                        <el-button type="primary" size="small" @click="orderEdit(scope.$index, scope.row)" style="margin-bottom: 10px;">订单详情</el-button>
                        <!-- 可处理：订单未发货状态 && 已接单 && 由当前登录账号接单 -->
                        <el-button
                            v-if="scope.row.canDelivery"
                            type="primary"
                            size="small"
                            style="margin-bottom: 10px;"
                            :disabled="Boolean(scope.row.is_expresses)"
                            @click="edit(scope.$index, scope.row)"
                        >整单发货</el-button>
                        <el-button type="primary" size="small" @click="orderEdit(scope.$index, scope.row)">多单号发货</el-button>
                        <!-- 可签收：订单已发货状态 && 当前时间大于配送时间中的起始时间 && 由当前登录账号接单 -->
                        <template v-if="is_allocation">
                            <el-button
                                v-if="scope.row.canSign"
                                type="primary"
                                size="small"
                                style="margin-bottom: 10px;"
                                @click="onPick(scope.row.order_id)"
                            >签收</el-button>
                        </template>
                        <el-dropdown>
                            <el-button type="primary" size="small">
                                更多 <i class="el-icon-arrow-down"></i>
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <template v-if="scope.row.ship_type == 'same'">
                                    <!-- 非预售商品超过支付时间48小时不允许配置延迟发货 -->
                                        <el-dropdown-item
                                            v-if="!scope.row.yushou_end_date"
                                            :disabled="new Date().getTime() - new Date(scope.row.paid_at).getTime() > 1000 * 60 * 60 * 48 || (scope.row.reject_status==0 || scope.row.reject_status==1) || Boolean(scope.row.is_expresses) || scope.row.is_operate !== true"
                                            :title="onTips(scope.row)"
                                            @click="openDelayDialog(scope.row)">
                                            延迟发货
                                        </el-dropdown-item>
                                    <!-- 预售商品超过预售结束时间48小时不允许配置延迟发货 -->
                                        <el-dropdown-item
                                            v-else
                                            :disabled="Date.now() <=new Date(scope.row.yushou_end_date+' 23:59:59 ').getTime() || Date.now() >= new Date(scope.row.yushou_end_date+' 23:59:59 ').getTime()+1000*60*60*48 || Boolean(scope.row.is_expresses) || (scope.row.reject_status==0 || scope.row.reject_status==1) || scope.row.is_operate !== true"
                                            :title="onTips(scope.row)"
                                            @click="openDelayDialog(scope.row)">
                                            延迟发货
                                        </el-dropdown-item>
                                    </template>
                                    <el-dropdown-item type="primary" size="small" @click="remarkDialog(scope.row)">备注</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="count" @pageChange="handleCurrentChange" @sizeChange="handleSizeChange" />

        <!-- 发货弹框 -->
        <el-dialog title="订单发货" v-model="dialogOldFormVisible" @close="closeAddExpressCpDialog()">
            <div style="color: red;margin-left: 30px;margin-bottom: 12px;" v-if="displayMessage">{{ displayMessage}}</div>
            <el-form :model="addExpressCp" ref="addExpressCpForm" label-width="170px" :rules="expressCpRules">
                <el-form-item :label="addExpressCp.ship_type == 'same' ? '物流单号' : '配送员电话'" prop="express_no">
                    <el-input clearable :placeholder="addExpressCp.ship_type == 'same' ? '请填写物流单号' : '请填写配送员电话'" 
                        @input="addExpressCp.express_no = addExpressCp.express_no.replace(addExpressCp.ship_type == 'same' ? /[^a-zA-Z0-9\-\(\)]/g : /[^0-9\-\(\)]/g, '')" 
                        v-model="addExpressCp.express_no" 
                        autocomplete="off" 
                        @blur="addExpressCp.ship_type == 'same' ? getExpressInfo() : validateExpressPhone(addExpressCp.express_no)">
                    </el-input>
                    <div v-if="expressPhoneError" style="color: red; font-size: 12px;">{{ expressPhoneError }}</div>
                </el-form-item>
                <el-form-item label="寄件人电话" prop="originator_phone" v-if="addExpressCp.ship_type == 'same'">
                    <el-input clearable placeholder="请填写寄件人电话" v-model="addExpressCp.originator_phone" autocomplete="off" @input="handleInput"></el-input>
                </el-form-item>
                <el-form-item :label="addExpressCp.ship_type == 'same' ? '物流公司' : '配送员姓名'" prop="express_cp">
                    <el-input v-model="addExpressCp.express_cp" autocomplete="off" :disabled="addExpressCp.disabled"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="coupon_money">
                    <el-input type="textarea" v-model="addExpressCp.remark" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="closeAddExpressCpDialog()">取 消</el-button>
                    <el-button type="primary" @click="submitAddExpressCp()" :disabled="expressPhoneError !== ''">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 延迟发货弹框 -->
        <el-dialog title="延迟发货" v-model="dialogDeliveryFormVisible" :before-close="beforeDelayDialogClose">
            <el-form :model="currRow" ref="addDeliveryForm" label-width="170px" :rules="deliveryRules">
                <el-form-item label="延迟发货类型" prop="delay_delivery_type">
                    <el-select v-model="currRow.delay_delivery_type" @change="currRow.delay_delivery_time = ''"
                        placeholder="选择延迟发货类型">
                        <!-- <el-option :value="0" label="选择延迟发货类型"></el-option> -->
                        <el-option :value="DelayTypes['商品无货']" v-if="!currRow.yushou_end_date" label="商品无货"></el-option>
                        <el-option :value="DelayTypes['客户原因']" label="客户原因"></el-option>
                        <el-option :value="DelayTypes['其他']" label="其他"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="延迟发货时间" prop="delay_delivery_time">
                    <el-date-picker v-if="currRow.delay_delivery_type == DelayTypes['客户原因']"
                        v-model="currRow.delay_delivery_time" :disabled-date="disabledDate"
                        value-format="YYYY-MM-DD HH:mm:ss" type="datetime" placeholder="选择延迟发货时间"></el-date-picker>
                    <el-select v-else v-model="currRow.delay_delivery_time" placeholder="选择延迟发货时间">
                        <!-- <el-option value="0000-00-00 00:00:00" label="选择延迟发货时间"></el-option> -->
                        <el-option v-for="item in selectableTimeList" :key="item" :value="item" :label="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="延迟发货原因" prop="delay_reson">
                    <el-input type="textarea" v-model.trim="currRow.delay_reson" autocomplete="off" maxlength="150"
                        show-word-limit :rows="4" style="width:280px"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="beforeDelayDialogClose">取 消</el-button>
                    <el-button type="primary" @click="onDelaySave">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 批量发货弹框 -->
        <el-dialog :title="`按${batchType === 'order' ? '订单' : '商品'}批量发货`" v-model="dialogBatchDelivery"
            :before-close="beforeBatchDialogClose">
            <el-form class="form" label-width="150px">
                <el-form-item label="批量发货：" prop="image">
                    <el-upload class="avatar-uploader" ref="batchDeliveryForm"
                        v-model:file-list="fileList"
                        :action="`/api/admin/merchant/${batchType === 'order' ? 'batchDelivery' : 'batchDeliveryProduct'}?user_id=${store.state.user.userInfo.id}`"
                        :show-file-list="true" :on-success="handleAvatarSuccess"
                        :auto-upload="false"
                        :limit="1"
                        :on-exceed="handleExceed"
                        accept=".xls,.xlsx">
                        <i class="el-icon-plus avatar-uploader-icon">选取文件</i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link
                        :href="`${Keys.baseUrl}/admin/merchant/${batchType === 'order' ? 'downLoadExcel' : 'downLoadExcelProduct'}`"
                        type="primary">{{ `下载按${batchType === 'order' ? '订单' : '商品'}批量发货模板` }}</el-link>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="beforeBatchDialogClose">取 消</el-button>
                    <el-button type="success" @click="submitUpload()">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 商家备注弹窗 -->
        <el-dialog title="商家备注" v-model="dialogRmarkFormVisible">
            <el-form :model="addRemark" ref="addRemarkForm" :rules="expressCpRules">
                <el-form-item>
                    <el-input type="textarea" v-model.trim="addRemark.seller_msg" maxlength="50" show-word-limit></el-input>
                    <p style="color: red;">*此备注作为蛋糕叔叔与用户的沟通凭证，请注意言论。</p>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogRmarkFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitRemark()">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 分配订单弹框 -->
        <el-dialog title="门店分配" v-model="dialogDistributeVisible">
            <el-form :model="currRow" ref="distributeForm" label-width="170px">
                <el-form-item label="收货人姓名：">
                    <el-row>{{ currRow.name }}</el-row>
                </el-form-item>
                <el-form-item label="收货人电话：">
                    <el-row>{{ currRow.phone }}</el-row>
                </el-form-item>
                <el-form-item label="收货人地址：">
                    <el-row>{{ `${currRow.province} ${currRow.city} ${currRow.area} ${currRow.addr}` }}</el-row>
                </el-form-item>
                <el-form-item label="选择门店：">
                    <el-select v-model="distributeShopId" placeholder="请选择门店" filterable clearable>
                        <el-option v-if="currRow.distributeType == 2" v-for="item in distributeShopList" :key="item.take_shop_id" :label="`${item.shop_name}（${item.distance}）`" :value="item.take_shop_id"></el-option>
                        <el-option v-else v-for="item in distributeShopList" :key="item.id" :label="`${item.name}（${item.distance}）`" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogDistributeVisible = false; distributeShopId = ''">取 消</el-button>
                    <el-button type="primary" @click="onDistribute()">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 绑定微信弹框 -->
        <FollowWxDialog ref="followWxDialog" />
    </div>
</template>
<script>
import { onBeforeRouteLeave, useRouter, userRoute } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, computed, watch, nextTick, onActivated } from 'vue'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import { DelayStatus, DelayTypes, OrderPickStatus, OrderStatus } from '@/enums/order'
import { getDelayTime, dateFormat, getLastMonthToday, getCurrentDate } from '@/utils/index'
import Pagination from '@/components/Pagination'
import { isSensitive } from '@/utils/validator'
import { saveDistributeApi, pickOrderApi, getExpressInfoApi } from '../../apis/order'
import { getPickShopListApi, getDistributeShopListApi } from '../../apis/shop'
import FollowWxDialog from '@/components/FollowWxDialog'
import { deliveryTypes } from './enum'
import { ElMessageBox } from 'element-plus'
import SelectMerchantSecondBrand from '@/components/SelectMerchantSecondBrand'
import { isValidTel,isValidMobile } from '@/utils/validator'

export default defineComponent({
    name: 'MerchantList',
    components: { Pagination, FollowWxDialog, SelectMerchantSecondBrand },
    setup() {
        const { proxy } = getCurrentInstance()
        const router = useRouter()
        const route = useRoute()
        const store = useStore()
        const { o } = route.query
        let check_zh = (rule, val, callback) => {
            if (!/[\u4E00-\u9FA5A-Za-z]/g.test(val)) {
                callback(new Error('只能是汉字或英文'))
            }
            callback();
        }

        const disabledDate = (date) => {
            // 今天可选
            return date.getTime() + 1000 * 60 * 60 * 24 < Date.now()
        }
        // 支付开始时间限制：非历史订单时只能选择 2026-01-01 及以后
        const disabledStartDate = (date) => {
            if (state.filters.is_history) return false
            const limitDate = new Date('2026-01-01')
            return date.getTime() < limitDate.getTime()
        }
        // 支付结束时间限制：历史订单时只能选择 2026-01-01 之前
        const disabledEndDate = (date) => {
            if (!state.filters.is_history) return false
            const limitDate = new Date('2026-01-01')
            return date.getTime() >= limitDate.getTime()
        }
        const hasShop = store.state.user.userInfo.hasShop
        const is_allocation =  store.state.user.userInfo.is_allocation // 针对指定商家开发自主接单功能
        const today = new Date()
        const state = reactive({
            srcList: [],
            o: route.query.o || null,
            filters: {
                order_type: route.query.all ||!is_allocation ? 1 : hasShop ? 0 : 5,
                is_yushou: route.query.is_yushou || 0,
                tmp_secondary_id: [],
                yushou_start_date: '',
                yushou_end_date: '',
                order_no: '',
                name: '',
                delivery_type: route.query.t || '',
                phone: '',
                reject_status:'',
                time_type: '',
                start_date: route.query.start_date || getLastMonthToday(),
                end_date: route.query.end_date || getCurrentDate(),
                item_name: '',
                timeClick: '',
                is_history: false,
                shop_user_id: undefined,
                limit: 10,
                page: 1,
            },
            noticeArray:['该品仅限京东、顺丰发货','该品仅限京东物流发货','该品仅限顺丰发货'],
            displayMessage:'',//京东、顺丰物流分类提示
            addExpressCp: {
                order_id: '',
                phone: '',
                express_cp: '',
                express_no: '',
                originator_phone:'',
                user_id: '',
                remark: '',
                isNotice:0,
                ship_type:'',
            },
            addRemark: {
                order_id: '',
                seller_msg: '',
            },
            addDelivery: {
                order_id: '',
                delay_delivery_time: '',
                delay_delivery: ''
            },
            tableData: [],
            isLoading: false,  // 表格数据加载状态
            shopUserList: [],
            spanArr: null,
            pos: 0,
            count: 0,
            dialogOldFormVisible: false,
            dialogDeliveryFormVisible: false,
            dialogBatchDelivery: false,
            dialogRmarkFormVisible: false,//备注弹窗
            batchType: '',  // 批量发货类型：order-订单，product-商品
            fileList: [], // 上传文件信息
            tableHeight: 0, // table 动态高度
            currRow: {},  // 当前操作数据行

            dialogDistributeVisible: false, // 分配门店弹框
            distributeShopList: [], // 分配门店列表
            distributeShopId: '', // 分配门店ID
            expressPhoneError: '', // 寄件人电话错误提示
            
            onSelectedSecondBrandChange (val) {
                state.filters.secondary_id = val.join(',')
            },
            handleSizeChange(val) {
                state.filters.limit = val
                state.getList();
            },
            handleCurrentChange(val) {
                state.filters.page = val
                state.getList();
            },
            getList() {
                // state.isLoading = true
                const url = state.filters.is_history
                    ? '/admin/merchant/getOrderLists_history'
                    : '/admin/merchant/getOrderList'
                proxy.$http.get(`${url}?${joinParams(state.filters)}`).then(res => {
                    const { code, data, msg } = res
                    if (code != 0) {
                        state.tableData = []
                        state.count = 0
                        state.isLoading = false
                        return proxy.$message({ type: 'error', message: res.msg })
                    }
                    state.tableData = data.data
                    state.spanArr = data.data
                    state.count = data.total
                    state.getSpanArr(state.spanArr)
                    state.srcList = ['https://img.dangaoss.com/public/p/72/0/1176489_l.jpg']
                    /**
                     * 延迟发货状态判断：
                     * 未填写：reject_status==0 没有延迟发货信息
                     * 待审核状态：reject_status==0 有延迟发货信息
                     *      首次提交待审核：没有驳回原因
                     *      驳回后再次提交待审核：有驳回原因
                     * 驳回：reject_status==3 有延迟发货信息
                     * 审核通过：reject_status==1 有延迟发货信息
                     * 总结：当状态为待审核或审核通过时不可编辑，即有延迟发货信息且状态不等于 3 时，不可编辑
                    */
                    // state.tableData.map(item => {
                    //     const { id } = item
                    //     const fitIndex = state.tableData.findIndex(item => item.id == id && item.delay_delivery_type != 0 && item.reject_status != 3)
                    //     item.editable = fitIndex === -1
                    // })
                    state.tableData.map(item => {
                        const { ship_type, status, shop_status, express_cp, ship_date, ship_time_text } = item
                        /**
                         * 是否可接单
                         * */
                        let canPick = OrderPickStatus[shop_status] == '未接单' && (hasShop && OrderStatus[status] == '待确认' || !hasShop) && ship_type != 'same'
                        // 是否可分配
                        let canDistribute = hasShop && OrderStatus[status] == '待确认' && ship_type != 'same'
                        // 是否可发货
                        let canDelivery = true
                        if (is_allocation) {
                            // canDelivery = OrderStatus[status] == '已分配' && (express_cp == '' || express_cp == null) && (hasShop && OrderPickStatus[shop_status] == '总商户接单' || !hasShop && OrderPickStatus[shop_status] == '门店账号接单')
                            canDelivery = OrderStatus[status] == '已分配' && (express_cp == '' || express_cp == null)
                        } else {
                            canDelivery = (express_cp == '' || express_cp == null)
                        }
                        // 是否可签收
                        let canSign = ship_type != 'same' && (OrderStatus[status] == '已分配' && express_cp) && (Date.now() > new Date(ship_date + ' ' + ship_time_text.split('-')[0]).getTime()) && (hasShop && OrderPickStatus[shop_status] == '总商户接单' || !hasShop && OrderPickStatus[shop_status] == '门店账号接单')
                        
                        item.canPick = canPick
                        item.canDistribute = canDistribute
                        item.canDelivery = canDelivery
                        item.canSign = canSign
                    })
                    state.isLoading = false
                })
            },
            search(type) {
                if (type) {
                    state.filters.timeClick = type
                    state.filters.start_date = ''
                    state.filters.end_date = ''
                }
                state.filters.page = 1
                state.getList();
            },
            onHistoryChange(val) {
                state.filters.page = 1
                if (val) {
                    state.filters.start_date = '2025-12-01'
                    state.filters.end_date = '2025-12-31'
                } else {
                    state.filters.start_date = getLastMonthToday()
                    state.filters.end_date = getCurrentDate()
                }
                state.getList()
            },
            output() {
                window.open(`${Keys.baseUrl}/admin/merchant/merchantOrderOutput?${joinParams({ ...state.filters, user_id: store.state.user.userInfo.id })}`);
            },
            batchDelivery(type) {
                state.batchType = type
                state.dialogBatchDelivery = true;
            },
            getShopList: () => {
                proxy.$http.get(`/admin/shop_product/getShopList?user_id=${store.state.user.userInfo.id}`).then(res => {
                    if (res.code == 200) {
                        state.shopUserList = res.data;
                    } else {
                        state.shopUserList = [];
                    }
                })
            },
            // 上传文件超出限制时提示
            handleExceed: () => {
                proxy.$message({ type: 'warning', message: '最多只能上传一个文件' })
            },
            // 提交上传
            submitUpload: () => {
                if (state.fileList.length === 0) {
                    return proxy.$message({ type: 'warning', message: '请选择文件' })
                }
                store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
                proxy.$refs.batchDeliveryForm.submit()
            },
            // 批量发货-上传文件成功
            handleAvatarSuccess: (res, file) => {
                store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
                const { code, data, msg } = res
                if (code != 200) {
                    ElMessageBox.alert(msg, '提示', {
                        confirmButtonText: '知道了',
                        type: 'error',
                    })
                    proxy.$refs.batchDeliveryForm.clearFiles()
                    return
                }
                
                proxy.$message({ type: 'success', message: '发货成功' })
                proxy.$refs.batchDeliveryForm.clearFiles()
                state.dialogBatchDelivery = false
                setTimeout(() => {
                    state.getList()
                }, 2000)
            },
            // 批量发货-关闭弹框
            beforeBatchDialogClose: () => {
                proxy.$refs.batchDeliveryForm.clearFiles()
                state.dialogBatchDelivery = false
            },
            edit(index, row) {
                // router.push('/invoice/edit?id='+row.id);
                //数据置空
                state.displayMessage = '';
                state.addExpressCp.isNotice = 0;
                state.addExpressCp.express_cp = '';
                state.addExpressCp.express_no = '';
                state.addExpressCp.originator_phone = '';
                state.addExpressCp.remark = '';
                state.addExpressCp.order_id = row.order_id;
                state.addExpressCp.phone = row.phone;
                state.addExpressCp.user_id = store.state.user.userInfo.id;
                state.addExpressCp.label_name = row.label_name
                state.addExpressCp.ship_type = row.ship_type
                state.dialogOldFormVisible = true;
                // 检查是否包含京东或顺丰
                const containsJD = state.addExpressCp.label_name?.includes('京东');
                const containsSF = state.addExpressCp.label_name?.includes('顺丰');

                // 根据是否包含京东或顺丰进行判断
                if(state.addExpressCp.ship_type == 'same'){
                    state.addExpressCp.isNotice = containsJD && containsSF ? 1 :containsJD ? 2 :containsSF ? 3 : 0;
                }
            },
            // 打开分配订单弹框
            openDistribute (row, type = '') {
                row.distributeType = type
                state.currRow = row
                state.getDistributeShopList(row.order_id, type)
            },
            // 获取可接单/可分配（此类门店关联了门店账号）门店列表
            getDistributeShopList: async (order_id, type) => {
                const { code, data, msg } = type==2 ? await getPickShopListApi(order_id) : await getDistributeShopListApi(order_id)
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.distributeShopList = data
                state.dialogDistributeVisible = true
            },
            // 确认分配
            onDistribute () {
                const { currRow, distributeShopId } = state
                const { order_id, distributeType } = currRow
                if (!distributeShopId) {
                    return proxy.$message({ type: 'error', message: '请选择门店' })
                }
                saveDistributeApi(order_id, distributeShopId, distributeType).then((res) => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '操作成功' })
                    state.getList()
                    state.dialogDistributeVisible = false
                    state.distributeShopId = ''
                })
            },
            // 确认接单
            onPick (order_id) {
                proxy.$confirm('确认接收此单吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    pickOrderApi(order_id).then((res) => {
                        const { code, data, msg } = res
                        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                        proxy.$message({ type: 'success', message: '操作成功' })
                        state.getList()
                    })
                }).catch(() => {
                    console.log('取消接单')
                })
            },
            //备注弹窗提交
            submitRemark: () => {
                proxy.$refs['addRemarkForm'].validate((valid) => {
                    if (valid) {
                        isSensitive(state.addRemark.seller_msg).then((res) => {
                            if (res === true) {
                                proxy.$http.post('/admin/merchant/add_seller_msg', state.addRemark).then(res => {
                                    const { code, msg } = res
                                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                                    proxy.$message({ type: 'success', message: '备注保存成功' })
                                    state.dialogRmarkFormVisible = false
                                    state.getList()
                                })
                            } else {
                                proxy.$message({ type: 'error', message: `备注中包含敏感词：${res}` })
                            }
                        })

                    }
                })
            },

            //打开备注弹窗
            remarkDialog: (row) => {
                state.addRemark.order_id = row.order_id
                state.addRemark.seller_msg = row.seller_msg
                state.dialogRmarkFormVisible = true
            },
            // 打开延迟发货弹框
            openDelayDialog: (row) => {
                state.currRow.order_no = row.order_no
                state.currRow.paid_at = row.paid_at
                state.currRow.yushou_end_date = row.yushou_end_date
                state.dialogDeliveryFormVisible = true
                nextTick(() => {
                    proxy.$refs['addDeliveryForm'].clearValidate()
                })
            },
            /*
            不可选延迟发货的情况
                后端返回is_operate（均为对订单下某个商品的判断返回到订单列表中）
                    1.订单包含”预售”和“非预售”商品，请进订单详情操作
                    2.订单含有不同预售时间商品，请进订单详情操作
                    is_expresses = 1 已退款、已完成、已发货、已部分发货
                    3.根据订单下的商品进行状态的判断
                        订单已部分发货，请到详情页进行操作（reject_status！==3（已驳回）时，）
                前端判断
                    1.支付时间超48h不支持延迟发货
                    预售商品判断（以下两条仅为预售商品的判断，其余以上条件包含全部商品）
                    1.预售期间不支持延迟发货（包含预售开始结束当天23:59:59）
                    2.预售结束时间超48h不支持延迟发货
            */
            //根据订单判断不可选延迟发货的情况
            onTips: (row) => {
                if(row.is_operate !== true){
                    return row.is_operate
                }else if(Boolean(row.is_expresses)){
                    return '当前状态不可操作'
                }else if(!row.yushou_end_date && (Date.now() - new Date(row.paid_at).getTime() > 1000 * 60 * 60 * 48)){
                    return '支付时间超48h不支持延迟发货'
                }else if(row.yushou_end_date && (Date.now() <=new Date(row.yushou_end_date+' 23:59:59 ').getTime())){
                    return '预售期间不支持延迟发货'
                }else if(row.yushou_end_date && (Date.now() >=new Date(row.yushou_end_date+' 23:59:59 ').getTime()+1000*60*60*48)){
                    return '预售结束时间超48h不支持延迟发货'
                } 
            },
            // 延迟发货请求
            onDelaySave: () => {
                proxy.$refs['addDeliveryForm'].validate((valid) => {
                    if (valid) {
                        const { order_no, delay_delivery_type, delay_delivery_time, delay_reson } = state.currRow
                        proxy.$http.post(`/admin/merchant/delay_delivery`, {
                            order_no,
                            delay_delivery_type,
                            delay_delivery_time,
                            delay_reson
                        }).then((res) => {
                            if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
                            proxy.$message({ type: 'success', message: '操作成功' })
                            state.beforeDelayDialogClose()
                            state.getList()
                        })
                    }
                })
            },
            // 关闭延迟发货弹框前清空数据
            beforeDelayDialogClose: () => {
                state.currRow = {}
                state.dialogDeliveryFormVisible = false
            },
            addDeliveryFun: (index, row) => {
                state.addDelivery.delay_delivery_time = '',
                    state.addDelivery.delay_delivery = ''
                state.addDelivery.order_id = row.order_id;
                state.addDelivery.delay_delivery = row.delay_delivery;
                state.addDelivery.delay_delivery_time = row.delay_delivery_time;
                state.addDelivery.user_id = store.state.user.userInfo.id;
                state.dialogDeliveryFormVisible = true;
            },
            submitAddDelivery: () => {
                proxy.$refs['addDeliveryForm'].validate((value) => {
                    if (value) {
                        //提交物流信息
                        proxy.$http.post(`/admin/merchant/delay_delivery`, state.addDelivery).then((res) => {
                            if (res.code == 0) {
                                proxy.$message({ type: 'success', message: res.msg });
                            } else {
                                proxy.$message({ type: 'error', message: res.msg });
                            }
                        })
                    }
                })
            },
            // 获取物流公司信息
            getExpressInfo: async () => {
                state.expressPhoneError = "";
                const { express_no } = state.addExpressCp
                if (!express_no) {
                    row.express_cp = ''
                    state.addExpressCp.disabled = false;
                    return
                }
                const { code, data, msg } = await getExpressInfoApi(express_no)
                if (code == 200) {
                    // 更新当前 field 的物流公司信息
                    state.addExpressCp.express_cp = data.current_express_no;
                    state.addExpressCp.disabled = true;
                } else {
                    proxy.$message({ type: 'error', message: msg});
                    state.addExpressCp.disabled = false;
                    state.addExpressCp.express_cp = '';
                }
            },
                // 手机号输入时过滤非数字
            handleInput:(value) => {
                state.addExpressCp.originator_phone = value.replace(/\D-/g, '');
            },
            submitAddExpressCp: () => {
                const { addExpressCp } = state
                const { isNotice, express_cp } = addExpressCp
                proxy.$refs['addExpressCpForm'].validate((val) => {
                    if (val) {
                        //检验京东、顺丰快递输入是否合理
                        // 假设 express_cp 是一个字符串变量，包含当前的快递公司名称
                        // 假设 isNotice 是一个数字变量，表示特定的通知类型

                        // 根据isNotice值和express_cp内容更新noticeMessage
                        if ((isNotice === 1 && !express_cp.includes('京东') && isNotice === 1 && !express_cp.includes('顺丰')) ||
                            (isNotice === 2 && !express_cp.includes('京东')) ||
                            (isNotice === 3 && !express_cp.includes('顺丰'))) {
                            state.displayMessage = state.addExpressCp.isNotice > 0 ? state.noticeArray[state.addExpressCp.isNotice - 1] : ''
                            // noticeMessage = isNotice; // 直接使用isNotice的值
                        } else {
                           //提交物流信息
                            proxy.$http.post(`/admin/merchant/add_express`, state.addExpressCp).then((res) => {
                                if (res.code == 200) {
                                    proxy.$message({ type: 'success', message: res.msg });
                                    state.dialogOldFormVisible = false;
                                    state.getList()
                                } else {
                                    proxy.$message({ type: 'error', message: res.msg });
                                }
                            })
                        }
                        
                    }
                })
            },
            closeAddExpressCpDialog: () => {
                state.expressPhoneError = "";
                state.dialogOldFormVisible = false;
            },
            orderEdit: (index, row) => {
                router.push('/merchant-admin/order-edit?order_id=' + row.order_id);
            },
            getSpanArr: (resData) => {
                state.spanArr = []
                if (resData === null) {
                    return
                }
                for (let i = 0; i < resData.length; i++) {
                    if (i === 0) {
                        state.spanArr.push(1)
                        state.pos = 0
                    } else {
                        if (resData[i].order_id === resData[i - 1].order_id) {
                            state.spanArr[state.pos] += 1
                            state.spanArr.push(0)
                        } else {
                            resData[i].hasClass = true
                            state.spanArr.push(1)
                            state.pos = i
                        }
                    }
                }
            },
            objectSpanMethod: ({ row, column, rowIndex, columnIndex }) => {
                let columnArray = [0, 4, 5, 6, 8, 9, 12, 14]
                if(state.filters.is_yushou == 1){
                    columnArray = [0, 4, 5, 6, 8, 11, 13]
                }
                if (columnArray.includes(columnIndex)) {
                    const _row = state.spanArr[rowIndex]
                    const _col = _row > 0 ? 1 : 0
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            // 合并后的表格添加样式
            rowClassName: ({ row }) => {
                if (row.hasClass) {
                    return 'deep-border'
                }
                if (row.status == 3) {
                    return 'warning-row'
                }
            },
            // 打开关注微信公众号弹框
            onOpenFollowDialog: () => {
                nextTick(() => {
                    proxy.$refs.followWxDialog.openFollowDialog()
                })
            },
            // 下载手册文件
            onPreview: () => {
                window.open('https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/shop_vedio/收费附件添加教程1723017670.docx')
            }
        })

        // 校验延迟类型
        const validDelayType = (rule, val, callback) => {
            if (val == 0) {
                callback(new Error('请选择延迟发货类型'))
            } else {
                callback()
            }
        }
        // 校验延迟时间
        const validDelayTime = (rule, val, callback) => {
            if (val == '0000-00-00 00:00:00') {
                callback(new Error('请选择延迟发货类型'))
            } else {
                callback()
            }
        }
        const validatePhone = (rule, val, callback) => {
                // 处理表单验证的情况
                const ship_flag = state.addExpressCp.ship_type !== 'same'
                if(ship_flag && val != ''){
                    if (!isValidTel(val) && !isValidMobile(val)) {
                        callback(new Error('请输入正确的手机号'))
                    }else {
                        callback()
                    }
                } else {
                    callback()
                }
            }
        const validateExpressPhone = (phone) => {
            if (phone != "") {
                if (!isValidTel(phone) && !isValidMobile(phone)) {
                state.expressPhoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
                }else {
                state.expressPhoneError = "";
                }
            }
        };
        const deliveryRules = reactive({
            delay_delivery_type: [
                { required: true, message: '请选择延迟发货类型', trigger: 'change' },
                { validator: validDelayType, trigger: 'change' }
            ],
            delay_delivery_time: [
                { required: true, message: '请选择延迟发货时间', trigger: 'change' },
                { validator: validDelayTime, trigger: 'change' }

            ],
            delay_reson: [
                { required: true, message: '请填写延迟发货原因', trigger: 'blur' }
            ]
        })
        const expressCpRules = reactive({
            express_cp: [
                { required: true, message: '请填写发货公司或者快递员姓名', trigger: 'blur' },
                { validator: check_zh, trigger: 'blur' }
            ],
            express_no: [
                { required: true, message: '请填写物流单号或者快递员电话', trigger: 'blur' },
            ],
            originator_phone: [
                // { required: true, message: '请填写寄件人手机号', trigger: 'blur' },
                { validator: validatePhone, trigger: 'blur' }
            ],
        })
        
        /**
         *  设置 商品无货、其他 状态下，可选延迟发货时间列表
         *  商品无货情况下，延迟发货只能选择 支付时间 + 48小时 + 30 的时间，即[30]
         *  其他情况下，延迟发货只能选择 支付时间 + 30 的时间，即[30]
         * */
        const selectableTimeList = computed(() => {
            const { paid_at, delay_delivery_type } = state.currRow
            let dateArr = []
            if (delay_delivery_type == DelayTypes['商品无货'] || delay_delivery_type == DelayTypes['其他']) {
                dateArr = [2,3,4,5,6,7]
            }
            // 将 paid_at 转换为 Date 对象
            let paidAtDate = new Date(paid_at);

            // 提取 paid_at 的年、月、日，并将时、分、秒设为 23:59:59
            let stopTime = `${paidAtDate.getFullYear()}-${String(paidAtDate.getMonth() + 1).padStart(2, '0')}-${String(paidAtDate.getDate()).padStart(2, '0')} 23:59:59`;
            let timeList = dateArr.map(item => getDelayTime(stopTime, item))
            return timeList
        })
        // const displayMessage = computed(() => {
        //    // 假设 state.noticeArray 是一个数组，包含所有可能的通知消息
        //     // 注意：这里假设 noticeMessage 的值恰好对应 state.noticeArray 的索引
        //     return state.addExpressCp.isNotice > 0 ? state.noticeArray[state.addExpressCp.isNotice - 1] : '';
        // })
        // 设置 table 高度
        const setTableHeight = () => {
            nextTick(() => {
                let headerHeight = 50,  // 头部高度
                    filterHeight = proxy.$refs.filterContainer.offsetHeight + 30, // 搜索条件框高度 + 间距
                    paginationHeight = 62 // 分页栏高度 + 与 table 之间的间距
                state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight
            })
        }
        // 设置 table 高度
        setTableHeight()
        // 监听窗口变化，重置 table 高度
        window.onresize = setTableHeight
        const rowClassName = ({ row }) => {
            if (row.status == 3) {
                return 'warning-row'
            }
        }
        // 注销 onresize 监听
        onBeforeRouteLeave(() => { window.onresize = null })
        watch(() => router.currentRoute.value, (newVal, oldVal) => {
            if (newVal.path === oldVal.path) {
                //若有则传递新的值，没有传默认的0
                state.filters.is_yushou = newVal.query.is_yushou || 0
                //重新调用接口数据
                state.search()
            }
        })
        onActivated(() => {
            if(route.query.o == 'order'){
                state.filters.order_type =  route.query.all
                state.filters.start_date = route.query.start_date || getLastMonthToday()
                state.filters.end_date = route.query.end_date || getCurrentDate()
                state.filters.delivery_type = route.query.t || '',
                state.filters.page = 1
            }
            state.getList()
        })
        hasShop && state.getShopList()
        return { ...toRefs(state), rowClassName, router, hasShop, is_allocation, expressCpRules, deliveryRules, Keys, deliveryTypes, store, DelayStatus, DelayTypes, selectableTimeList, disabledDate, disabledStartDate, disabledEndDate, OrderPickStatus, FollowWxDialog, validateExpressPhone }
    }
})
</script>
<style>
    :deep(.el-table-fixed-column--right) {
        z-index: 100 !important; /* 默认值为 2，需高于普通单元格 */
        height: 100% !important; /* 确保高度覆盖 */
    }
</style>
<style lang="stylus" scoped>
    .follow-alert
        margin -10px 0 10px
        p
            font-size 13px
        .el-link
            transform translateY(-1px)
    .demo-table-expand
        font-size 0
    .demo-table-expand label
        width 90px
        color #99a9bf
    .demo-table-expand .el-form-item
        margin-right 0
        margin-bottom 0
        width 50%
    :deep(.deep-border td)
        border-top 1px solid #999
    :deep(.el-table tbody tr:hover > td)
        background-color transparent !important
    .avatar-uploader
        width 50%
    :deep(.el-table .warning-row)
        opacity 0.5
        position relative
        &::after
            content: "已退单";
            position: absolute;
            left: 120px;
            top: 50%;
            z-index: 2;
            font-size: 24px;
            color: red;
            font-weight: bold;
            transform: rotate(-29deg) translateY(-50%);
</style>